// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RegistrationForm_registrationHeader__KQdd\\+ {
    text-align: center;
    font-size: 2.5rem;
    margin-top: 5rem;
    margin-bottom: 2rem;
    font-family: "Ysabeau SC";
    color: #333;
}

.RegistrationForm_registrationForm__aHg\\+R {
    max-width: 800px;
    margin: 2rem auto;
    padding: 2rem;
    background-color: #ffffff;
    border-radius: 1rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.RegistrationForm_registrationField__WK0RA {
    border: solid 0.1rem #dddddd;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    display: flex;
    background-color: #f9f9f9;
}

.RegistrationForm_inputArea__wsU\\+A,
.RegistrationForm_descriptionArea__OpSy5 {
    flex: 1 1;
    padding: 1rem;
}

.RegistrationForm_descriptionHeader__2PDU\\+ {
    font-size: 1.5rem;
    color: #333333;
    font-weight: bold;
}

.RegistrationForm_description__5otKF {
    color: #555555;
    margin-top: 0.5rem;
}

.RegistrationForm_inputArea__wsU\\+A .RegistrationForm_form-floating__AqxIn {
    margin-bottom: 1rem;
}

#RegistrationForm_passwordVisible__y3WsA {
    margin-right: 0.5rem;
}

input[type="submit"] {
    display: block;
    margin: 1.5rem auto 0;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    color: #ffffff;
    background-color: #007bff;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

input[type="submit"]:hover {
    background-color: #0056b3;
}

/* Стиль для пароля */
.RegistrationForm_passwordField__52yY0 {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
}

.RegistrationForm_passwordInput__ZJTcM {
    flex: 1 1;
    padding-right: 2.5rem;
}

.RegistrationForm_showPasswordIcon__Xg7x2 {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 1.5rem;
    color: #888;
    transition: color 0.3s;
}

.RegistrationForm_showPasswordIcon__Xg7x2:hover {
    color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/components/Registration/RegistrationForm.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;IAEI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".registrationHeader {\r\n    text-align: center;\r\n    font-size: 2.5rem;\r\n    margin-top: 5rem;\r\n    margin-bottom: 2rem;\r\n    font-family: \"Ysabeau SC\";\r\n    color: #333;\r\n}\r\n\r\n.registrationForm {\r\n    max-width: 800px;\r\n    margin: 2rem auto;\r\n    padding: 2rem;\r\n    background-color: #ffffff;\r\n    border-radius: 1rem;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.registrationField {\r\n    border: solid 0.1rem #dddddd;\r\n    border-radius: 0.5rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.inputArea,\r\n.descriptionArea {\r\n    flex: 1;\r\n    padding: 1rem;\r\n}\r\n\r\n.descriptionHeader {\r\n    font-size: 1.5rem;\r\n    color: #333333;\r\n    font-weight: bold;\r\n}\r\n\r\n.description {\r\n    color: #555555;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.inputArea .form-floating {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n#passwordVisible {\r\n    margin-right: 0.5rem;\r\n}\r\n\r\ninput[type=\"submit\"] {\r\n    display: block;\r\n    margin: 1.5rem auto 0;\r\n    padding: 0.5rem 1.5rem;\r\n    font-size: 1rem;\r\n    color: #ffffff;\r\n    background-color: #007bff;\r\n    border: none;\r\n    border-radius: 0.5rem;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\ninput[type=\"submit\"]:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n/* Стиль для пароля */\r\n.passwordField {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.passwordInput {\r\n    flex: 1;\r\n    padding-right: 2.5rem;\r\n}\r\n\r\n.showPasswordIcon {\r\n    position: absolute;\r\n    right: 10px;\r\n    cursor: pointer;\r\n    font-size: 1.5rem;\r\n    color: #888;\r\n    transition: color 0.3s;\r\n}\r\n\r\n.showPasswordIcon:hover {\r\n    color: #333;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"registrationHeader": `RegistrationForm_registrationHeader__KQdd+`,
	"registrationForm": `RegistrationForm_registrationForm__aHg+R`,
	"registrationField": `RegistrationForm_registrationField__WK0RA`,
	"inputArea": `RegistrationForm_inputArea__wsU+A`,
	"descriptionArea": `RegistrationForm_descriptionArea__OpSy5`,
	"descriptionHeader": `RegistrationForm_descriptionHeader__2PDU+`,
	"description": `RegistrationForm_description__5otKF`,
	"form-floating": `RegistrationForm_form-floating__AqxIn`,
	"passwordVisible": `RegistrationForm_passwordVisible__y3WsA`,
	"passwordField": `RegistrationForm_passwordField__52yY0`,
	"passwordInput": `RegistrationForm_passwordInput__ZJTcM`,
	"showPasswordIcon": `RegistrationForm_showPasswordIcon__Xg7x2`
};
export default ___CSS_LOADER_EXPORT___;
